import { EmailStatus, EmailType } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { GridList } from '@tribeplatform/react-ui-kit/Layout'

// Filter state & reducer
type FilterOptions = {
  type: EmailType | undefined
  status: EmailStatus | undefined
  recipient: string | undefined
}

type FiltersAction =
  | { type: 'SET_TYPE'; payload: EmailType | undefined }
  | { type: 'SET_STATUS'; payload: EmailStatus | undefined }
  | { type: 'SET_RECIPIENT'; payload: string | undefined }

export const EmailLogsFilterBar = ({
  filters,
  dispatchFilters,
  emailTypeOptions,
  emailStatusOptions,
  setEmailStatusModal,
  handleRecipientChange,
}: {
  filters: FilterOptions
  dispatchFilters: (action: FiltersAction) => void
  emailTypeOptions: Array<{ value: EmailType; text: string }>
  emailStatusOptions: Array<{ value: string; text: string }>
  setEmailStatusModal: (open: boolean) => void
  handleRecipientChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const { $t } = useI18n()

  return (
    <Form
      onSubmit={null}
      defaultValues={{
        recipient: filters.recipient,
        type: filters.type,
        status: filters.status,
      }}
      className="w-full"
    >
      <GridList columns={3}>
        <GridList.Item>
          <Form.Input
            name="recipient"
            label={$t({
              defaultMessage: 'Recipient',
              id: 'Generics.Recipient',
            })}
            placeholder={$t({
              defaultMessage: 'Search for email...',
              id: 'Generics.SearchForEmailDotDotDot',
            })}
            onChange={handleRecipientChange}
          />
        </GridList.Item>
        <GridList.Item>
          <Form.Select
            name="type"
            label={$t({
              defaultMessage: 'Email type',
              id: 'Generics.EmailType',
            })}
            placeholder={$t({
              defaultMessage: 'All types',
              id: 'Generics.AllTypes',
            })}
            onChange={value =>
              dispatchFilters({ type: 'SET_TYPE', payload: value })
            }
            items={emailTypeOptions}
          />
        </GridList.Item>
        <GridList.Item>
          <Form.Select
            name="status"
            label={
              <div className="items-center flex space-s-1">
                <div>
                  <T defaultMessage="Email status" id="Generics.EmailStatus" />
                </div>
                <button type="button" onClick={() => setEmailStatusModal(true)}>
                  <SvgIcon className="w-4 h-4" name="info" />
                </button>
              </div>
            }
            placeholder={$t({
              defaultMessage: 'All statuses',
              id: 'Generics.AllStatuses',
            })}
            onChange={value =>
              dispatchFilters({ type: 'SET_STATUS', payload: value })
            }
            items={emailStatusOptions}
          />
        </GridList.Item>
      </GridList>
    </Form>
  )
}
